import { ReactNode } from 'react';
import styles from './styles.module.css';
import SideBar from '../sidebar';
import classNames from 'classnames';
import { useSelector } from 'react-redux';
import { AppState } from '../../redux/store';

type Props = {
  children?: ReactNode;
};

/**
 * サイドバー付きレイアウト
 */
function SidebarLayout({ children }: Props) {
  const overlayed = useSelector(
    (state: AppState) => state.settings.sidebar.overlayed
  );

  return (
    <div className={styles.host}>
      <div
        className={classNames(styles.sidebar, overlayed && styles.overlayed)}
      >
        <SideBar />
      </div>
      <main className={styles.main}>{children}</main>
    </div>
  );
}

export default SidebarLayout;
